import axios from 'axios';


const url = process.env.REACT_APP_BASE_API_URL;

export const reanaliseFindByReaid = async(reaId) => {
    const headers = { 'Content-Type': 'application/json'};
    return await axios.get(url + '/v1/reanalise/findbyid/' + reaId, {headers});
}

export const reanaliseInsert= async(reanalise) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.post(url + '/v1/reanalise/insert', reanalise, {headers});
}

export function reanaliseUpdate(reanalise) {
  const headers = { 'Content-Type': 'application/json'};
  return axios.put(url + '/v1/reanalise/update', reanalise, {headers});
}
    
export const reanaliseDelete = async(reanalise) => {
  const headers = { 'Content-Type': 'application/json'};
  return await axios.delete(url + '/v1/reanalise/delete', {data: reanalise}, {headers});
}
